import { ConsoleLogDestination } from './ConsoleLogDestination';
import { Logger } from './Logger';

const isProd = process.env.NODE_ENV === 'production';

const destinations = [];

if (!isProd) {
  destinations.push(new ConsoleLogDestination());
}

export const logger = new Logger(destinations);
